import {AfterViewInit, Component, OnInit} from '@angular/core';
import {DialogModel} from '@shared/models/dialog.model';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {Subject} from 'rxjs';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';

@Component({
    standalone: false,
    selector: 'particle-start-data-survey-dialog',
  templateUrl: './start-data-survey-dialog.component.html',
  styleUrls: ['./start-data-survey-dialog.component.scss']
})
export class StartDataSurveyDialogComponent implements OnInit, IDialogView, AfterViewInit {

  data: DialogModel;
  ngUnsubscribe = new Subject<void>();
  constructor(private flowChartDataService: FlowChartDataService) {

  }

  ngOnInit() {

  }
  ngAfterViewInit (): void {

  }
  onSelectStatusChange() {

  }
  onOkClicked(): boolean {
    return true;
  }

}
